import React from 'react';

const CampaignAnalyticsCards = ({
  analytics,
  showCombinedBadge = false,
  selectedCampaignsCount = 0,
  onReset,
  formatCurrency,
  formatPercentage,
  rangeTotalSpend = null
}) => {
  if (!analytics) return null;

  const {
    totalCampaigns,
    totalCustomers,
    customersWithOrders,
    totalOrders,
    totalGMV,
    totalSpend,
    totalLogins,
    avgConversionRate,
    overallROI,
    costPerActivity,
    avgOrderValue,
    costPerOrder,
    newCustomersAcquired,
    customerAcquisitionCost
  } = analytics;

  return (
    <div className="performance-summary">
      {showCombinedBadge && (
        <div className="combined-analytics-badge">
          <span>📊 Combined Analytics ({selectedCampaignsCount} campaign{selectedCampaignsCount !== 1 ? 's' : ''})</span>
          <button onClick={onReset} className="reset-analytics-button">
            Reset
          </button>
        </div>
      )}
      
      <div className="analytics-cards-grid">
        <div className="summary-card">
          <div className="summary-value">{totalCampaigns}</div>
          <div className="summary-label">Total Campaigns</div>
        </div>
        
        <div className="summary-card">
          <div className="summary-value">{totalCustomers?.toLocaleString() || 0}</div>
          <div className="summary-label">Customers Reached</div>
        </div>
        
        <div className="summary-card">
          <div className="summary-value">
            {customersWithOrders?.toLocaleString() || 0} ({formatPercentage(avgConversionRate)})
          </div>
          <div className="summary-label">Converted</div>
        </div>
        
        <div className="summary-card">
          <div className="summary-value">{totalOrders?.toLocaleString() || 0}</div>
          <div className="summary-label">Orders Generated</div>
        </div>
        
        <div className="summary-card">
          <div className="summary-value">{formatCurrency(totalGMV || 0)}</div>
          <div className="summary-label">Total GMV</div>
        </div>

        <div className="summary-card">
          <div className="summary-value">{formatCurrency(totalSpend || 0)}</div>
          <div className="summary-label">Combined Cost</div>
        </div>

        {rangeTotalSpend !== null && (
          <div className="summary-card">
            <div className="summary-value">{formatCurrency(rangeTotalSpend || 0)}</div>
            <div className="summary-label">Selected Range Combined Cost</div>
          </div>
        )}
        
        <div className="summary-card">
          <div className="summary-value">
            {avgOrderValue !== undefined && avgOrderValue !== null && avgOrderValue > 0
              ? formatCurrency(avgOrderValue)
              : '—'
            }
          </div>
          <div className="summary-label">AOV</div>
        </div>
        
        <div className="summary-card">
          <div className="summary-value">{overallROI ? `${overallROI.toFixed(2)}x` : '0x'}</div>
          <div className="summary-label">ROI</div>
        </div>
        
        <div className="summary-card">
          <div className="summary-value">
            {costPerOrder !== undefined && costPerOrder !== null
              ? formatCurrency(costPerOrder)
              : '—'
            }
          </div>
          <div className="summary-label">Cost per Order</div>
        </div>
        
        <div className="summary-card">
          <div className="summary-value">{totalLogins?.toLocaleString() || 0}</div>
          <div className="summary-label">Activity in 24 hrs</div>
        </div>
        
        <div className="summary-card">
          <div className="summary-value">
            {costPerActivity !== undefined && costPerActivity !== null
              ? formatCurrency(costPerActivity)
              : '—'
            }
          </div>
          <div className="summary-label">Cost per Activity</div>
        </div>
        
        <div className="summary-card">
          <div className="summary-value">{formatPercentage(avgConversionRate)}</div>
          <div className="summary-label">Conversion Rate</div>
        </div>

        <div className="summary-card">
          <div className="summary-value">{newCustomersAcquired?.toLocaleString() ?? 0}</div>
          <div className="summary-label">New Customers Acquired</div>
        </div>

        <div className="summary-card">
          <div className="summary-value">
            {customerAcquisitionCost !== undefined && customerAcquisitionCost !== null && customerAcquisitionCost > 0
              ? formatCurrency(customerAcquisitionCost)
              : '—'
            }
          </div>
          <div className="summary-label">Customer Acquisition Cost</div>
        </div>
      </div>
    </div>
  );
};

export default CampaignAnalyticsCards;


